import { device } from 'component-library/styles/device';
import React, { FC, PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

export enum Screen {
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
  Xl = 'xl',
  Xxl = 'xxl',
}

export interface ShowOnProps {
  screens: Screen[];
}

const show = (showOn: Screen[], screen: Screen) => showOn.includes(screen);

export const showOnStyles = css<ShowOnProps>`
  display: ${({ screens }) => (show(screens, Screen.Sm) ? 'revert' : 'none')};

  ${`@media ${device.md}`} {
    display: ${({ screens }) => (show(screens, Screen.Md) ? 'revert' : 'none')};
  }

  ${`@media ${device.lg}`} {
    display: ${({ screens }) => (show(screens, Screen.Lg) ? 'revert' : 'none')};
  }

  ${`@media ${device.xl}`} {
    display: ${({ screens }) => (show(screens, Screen.Xl) ? 'revert' : 'none')};
  }

  ${`@media ${device.xxl}`} {
    display: ${({ screens }) =>
      show(screens, Screen.Xxl) ? 'revert' : 'none'};
  }
`;

const ShowOnWrapper = styled.div<ShowOnProps>`
  ${showOnStyles}
`;

export const ShowOn: FC<PropsWithChildren<ShowOnProps>> = ({
  children,
  ...rest
}) => <ShowOnWrapper {...rest}>{children}</ShowOnWrapper>;

export const ShowOnDesktop: FC<PropsWithChildren> = ({ children }) => (
  <ShowOn screens={[Screen.Xl, Screen.Xxl]}>{children}</ShowOn>
);

export const ShowOnDesktopAndTablet: FC<PropsWithChildren> = ({ children }) => (
  <ShowOn screens={[Screen.Lg, Screen.Xl, Screen.Xxl]}>
    {children}
  </ShowOn>
);

export const ShowOnMobileAndTablet: FC<PropsWithChildren> = ({ children }) => (
  <ShowOn screens={[Screen.Sm, Screen.Md, Screen.Lg]}>{children}</ShowOn>
);

export const ShowOnMobile: FC<PropsWithChildren> = ({ children }) => (
  <ShowOn screens={[Screen.Sm, Screen.Md]}>{children}</ShowOn>
);